module.exports = __webpack_public_path__ + "static/media/1-sapo-concho1.1f9e9da8.jpg";